/**
 * How It Works: Scroll Scaling Stacking Cards Animation
 * Replicated exactly from Lovable source component.
 */

export const initHowItWorks = () => {
	const list = document.querySelector('[data-stack-list]');
	if (!list) return;

	const items = Array.from(list.children).filter((item) => item instanceof HTMLElement);
	if (!items.length) return;

	const media = window.matchMedia('(prefers-reduced-motion: no-preference) and (min-height: 601px)');
	let frame = 0;

	const update = () => {
		frame = 0;
		const positions = items.map((item) => item.getBoundingClientRect());

		items.forEach((item, index) => {
			let recession = 0;
			if (media.matches) {
				for (let next = index + 1; next < items.length; next++) {
					const nextItem = items[next];
					const nextPosition = positions[next];
					if (!nextItem || !nextPosition) continue;

					const pin = Number.parseFloat(window.getComputedStyle(nextItem).top) || 0;
					const distance = positions[index]?.height ?? 256;
					const progress = Math.max(0, Math.min(1, 1 - (nextPosition.top - pin) / distance));
					recession += progress * 0.03;
				}
			}

			const box = item.querySelector('.how-step-box') || item;
			box.style.setProperty('--how-scale', String(1 - recession));
		});
	};

	const schedule = () => {
		if (!frame) {
			frame = window.requestAnimationFrame(update);
		}
	};

	window.addEventListener('scroll', schedule, { passive: true });
	window.addEventListener('resize', schedule);
	media.addEventListener('change', schedule);

	if (window.ResizeObserver) {
		const observer = new ResizeObserver(schedule);
		observer.observe(list);
	}

	update();
};

if (typeof document !== 'undefined') {
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initHowItWorks);
	} else {
		initHowItWorks();
	}
}

